import React from "react";
import { Container, Typography, Box, Grid, LinearProgress, Paper } from "@mui/material";

function SkillBar({ label, value }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body1" sx={{ mb: 1 }}>{label}</Typography>
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: 10,
          borderRadius: 5,
          bgcolor: "#E6DBAC",
          "& .MuiLinearProgress-bar": { bgcolor: "#52B2BF" },
        }}
      />
    </Box>
  );
}

function Skills() {
  return (
    <Box id="skills" sx={{ py: 8, bgcolor: "background.paper" }}>
      <Container>
        <Typography variant="h4" gutterBottom>Skills</Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, color: "#52B2BF" }}>
                Backend
              </Typography>
              <SkillBar label="Java / Spring Boot" value={90} />
              <SkillBar label="REST APIs / Hibernate / JPA" value={85} />
              <SkillBar label="Database (MySQL / PostgreSQL)" value={80} />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, color: "#52B2BF" }}>
                Frontend & DevOps
              </Typography>
              <SkillBar label="React / JavaScript / HTML / CSS" value={85} />
              <SkillBar label="Docker / Kubernetes (learning) / CI/CD" value={70} />
              <SkillBar label="Tools (Git, Postman, n8n, Maven)" value={80} />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Skills;
